import CryptoJS from "crypto-js";

/**
 * Ofusca la contraseña antes de mandarla al login.
 *
 * Esto NO es cifrado en el sentido de seguridad: la clave viaja dentro del
 * bundle y cualquiera puede extraerla con las herramientas del navegador. Lo
 * que protege la contraseña en tránsito es HTTPS. La única razón de que exista
 * es que la API espera este formato (`LOGIN_TRANSPORT_KEY`).
 *
 * Se movió a una variable de entorno para poder rotarla en ambos lados a la
 * vez, sin editar código.
 */
const CLAVE_TRANSPORTE = process.env.REACT_APP_LOGIN_TRANSPORT_KEY || "controlC4hunters";

const Encrypt = (dato) => CryptoJS.AES.encrypt(dato, CLAVE_TRANSPORTE).toString();

export default Encrypt;
